import styled from 'styled-components';
import { TooltipHeader } from './TooltipCommon';

export const TaskHeader = styled(TooltipHeader)`
  margin: -12px -12px 8px -12px;
  padding: 10px 12px;
  background: linear-gradient(180deg, rgba(0,0,0,0.04), rgba(0,0,0,0));
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
`;

export const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 4px 0 8px;
`;

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  height: 18px;
  padding: 0 6px;
  border-radius: 999px;
  font-size: 10px;
  background: ${(props) => props.bg || props.theme.colors.backgroundHover};
  color: ${(props) => props.color || props.theme.colors.textSecondary};
  border: 1px solid ${(props) => props.border || props.theme.colors.borderLight};
`;

export const SectionTitle = styled.div`
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: .02em;
  color: ${(props) => props.theme.colors.textTertiary};
  margin: 8px 0 6px;
`;

export const Divider = styled.div`
  height: 1px;
  background: ${(props) => props.theme.colors.borderLight};
  margin: 8px -12px 8px;
`;

export const TaskDetails = styled.div`
  margin-top: 4px;
  background: ${(props) => props.theme.colors.backgroundLight};
  border: 1px solid ${(props) => props.theme.colors.borderLight};
  border-radius: 6px;
  padding: 8px;
`;

export const TaskRow = styled.div`
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 8px;
  font-size: 10px;
  margin-bottom: 4px;
  &:last-child { margin-bottom: 0; }
`;

export const TaskLabel = styled.span`
  color: ${(props) => props.theme.colors.textSecondary};
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TaskValue = styled.span`
  color: ${(props) => props.theme.colors.textPrimary};
  text-align: left;
`;

export const ScrollableValue = styled.div`
  max-height: 72px; /* ~4 lines */
  overflow-y: auto;
  color: ${(props) => props.theme.colors.textPrimary};
  text-align: left;
  white-space: pre-wrap;
`;

export const InfoCard = styled.div`
  background: transparent;
  border: 0;
  padding: 0;
  margin-bottom: 6px;
`;

export const InfoCardTitle = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.textPrimary};
  margin-bottom: 6px;
`;

export const InfoCardBody = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.colors.textPrimary};
  line-height: 1.5;
  white-space: pre-wrap;
  max-height: 120px;
  overflow-y: auto;
`;

